import React, {useState} from 'react';
import classNames from 'classnames';

import {InputError} from './';

const Input = ({
  label,
  light,
  dark,
  login,
  type,
  autoComplete,
  name,
  minLength,
  value,
  handleChange,
  placeholder,
  readOnly,
  required,
  hidden,
  disabled,
  empty,
  min,
  invalidEmail,
  invalidPhone,
  className,
}) => {
  const [visible, setVisible] = useState(false);

  const inputClass = classNames({
    'input-form input-color-light': light,
    'input-form': dark,
    'input-form input-login': login,
  });

  return (
    <label htmlFor={name} className={inputClass}>
      {label}
      <input
        onChange={handleChange}
        placeholder={placeholder}
        type={type}
        name={name}
        minLength={minLength}
        autoComplete={autoComplete}
        value={value}
        className={className ? className : 'input-form-field'}
        readOnly={readOnly}
        required={required}
        hidden={hidden}
        min={min}
        disabled={disabled}
        onBlur={() => setVisible(true)}
      />
      <InputError
        empty={empty}
        invalidEmail={invalidEmail}
        invalidPhone={invalidPhone}
        name={name}
        type={type}
        visible={visible}
      />
    </label>
  );
};

export default Input;
